// App.jsx
import './App.css';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

// Page imports
import Landing from './Pages/Landing/landing';
import Login from './Pages/Login/login';
import Dashboard from './Pages/Dashboard/dashboard';
import AddCustomer from './Pages/AddCustomer/add-customer';
import AddEmployees from './Pages/AddEmployees/add-emp';
import ViewEmployees from './Pages/ViewEmployees/view-emp';
import Scheduling from './Pages/Scheduling/scheduling';
import MyAccount from './Pages/MyAccount/myaccount';
import ViewCustomers from './Pages/ViewCustomers/viewcustomers';
import PassReset from './Pages/PassReset/passreset';
import MapView from './Pages/MapView/mapview';
import WorkOrdersPage from './Pages/workord-tab/workorderpage';
import TaskView from './Pages/TaskView/TaskView';
import EmployeeScheduling from './Pages/EmployeeScheduling/employee-scheduling';
import Reports from './Pages/Reports/reports';
import RoutesOption1 from './Pages/RoutesOption1/RoutesOption1';

// Component imports
import Navbar from './Components/Navbar/navbar';
import Sidebar from './Components/Sidebar/sidebar';
import Footer from './Components/Footer/footer';

// Import AuthProvider and RequireAuth
import { AuthProvider } from './Auth/AuthContext';
import RequireAuth from './Auth/RequireAuth';
import AdminDashboard from './Pages/AdminDashboard/admin-dash';
import AddCompany from './Pages/AddCompany/add-company';
import AuthCallback from './Auth/AuthCallback';
import Billing from './Pages/Payments/Billing';
import HelpFaq from './Pages/HelpFaq/HelpFaq';
import TemplatesPage from './Pages/Templates/TemplatesPage';

// Import Page Layout with AI Tips
import PageLayout from './Components/Layout/PageLayout';

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <>
        <Landing />
      </>
    ),
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/dash",
    element: (
      <RequireAuth>
        <PageLayout>
          <Sidebar />
          <Dashboard />
        </PageLayout>
      </RequireAuth>
    ),
  },
  {
    path: "/add-customer",
    element: (
      <RequireAuth>
        <PageLayout>
          <Sidebar />
          <AddCustomer />
        </PageLayout>
      </RequireAuth>
    ),
  },
  {
    path: "/work-orders",
    element: (
      <RequireAuth>
        <PageLayout>
          <Sidebar />
          <WorkOrdersPage />
        </PageLayout>
      </RequireAuth>
    ),
  },
  {
    path: "/add-emp",
    element: (
      <RequireAuth>
        <PageLayout>
          <Sidebar />
          <AddEmployees />
        </PageLayout>
      </RequireAuth>
    ),
  },
  {
    path: "/view-emp",
    element: (
      <RequireAuth>
        <PageLayout>
          <Sidebar />
          <ViewEmployees />
        </PageLayout>
      </RequireAuth>
    ),
  },
  {
    path: "/view-tasks",
    element: (
      <RequireAuth>
        <PageLayout>
          <Sidebar />
          <TaskView />
        </PageLayout>
      </RequireAuth>
    ),
  },
  {
    path: "/routes-option-1",
    element: (
      <RequireAuth>
        <PageLayout>
          <Sidebar />
          <RoutesOption1 />
        </PageLayout>
      </RequireAuth>
    ),
  },
  {
    path: "/scheduling",
    element: (
      <RequireAuth>
        <PageLayout>
          <Sidebar />
          <Scheduling />
        </PageLayout>
      </RequireAuth>
    ),
  },
  {
    path: "/employee-scheduling",
    element: (
      <RequireAuth>
        <PageLayout>
          <Sidebar />
          <EmployeeScheduling />
        </PageLayout>
      </RequireAuth>
    ),
  },
  {
    path: "/my-account",
    element: (
      <RequireAuth>
        <PageLayout>
          <Sidebar />
          <MyAccount />
        </PageLayout>
      </RequireAuth>
    ),
  },
  {
    path: "/view-customer",
    element: (
      <RequireAuth>
        <PageLayout>
          <Sidebar />
          <ViewCustomers />
        </PageLayout>
      </RequireAuth>
    ),
  },
  {
    path: "/billing",
    element: (
      <RequireAuth>
        <PageLayout>
          <Sidebar />
          <Billing />
        </PageLayout>
      </RequireAuth>
    ),
  },
  {
    path: "/reports",
    element: (
      <RequireAuth>
        <PageLayout>
          <Sidebar />
          <Reports />
        </PageLayout>
      </RequireAuth>
    ),
  },
  {
    path: "/payments",
    element: (
      <RequireAuth>
        <PageLayout>
          <Sidebar />
          <Billing />
        </PageLayout>
      </RequireAuth>
    ),
  },
  {
    path: "/map-view",
    element: (
      <RequireAuth>
        <PageLayout>
          <Sidebar />
          <MapView />
        </PageLayout>
      </RequireAuth>
    ),
  },

  {
    path: "/callback",
    element: <AuthCallback />,
  },
  
  {
    path: "/passreset",
    element: <PassReset />,
  },
  {
  path: "/admin",
  element: (
    <RequireAuth allowedGroups={['ASG_INNOVATEMORE_ADMIN_USER']}>
      <PageLayout>
        <Sidebar />
        <AdminDashboard />
      </PageLayout>
    </RequireAuth>
  ),
},
  {
    path: "/templates",
    element: (
      <RequireAuth>
        <PageLayout>
          <Sidebar />
          <TemplatesPage />
        </PageLayout>
      </RequireAuth>
    ),
  },
  {
    path: "/help-faq",
    element: (
      <RequireAuth>
        <PageLayout>
          <Sidebar />
          <HelpFaq />
        </PageLayout>
      </RequireAuth>
    ),
  },
  // App.jsx
{
  path: "/add-company",
  element: (
    <RequireAuth allowedGroups={['ASG_INNOVATEMORE_ADMIN_USER']}>
      <PageLayout>
        <Sidebar />
        <AddCompany />
      </PageLayout>
    </RequireAuth>
  ),
}
]);

function App() {
  return (
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  );
}

export default App;
